import { useMutation, UseMutationOptions } from 'react-query';
import { AxiosError } from "axios";

import request from "common/request";

type SendingLeadConversionAPIMutationVariable = {
  source?: string,
  medium?: string,
  fbclid?: string,
  content?: string,
  fbc? : string
};

export const useSendingLeadConversionAPI = (
  options?: UseMutationOptions<any, AxiosError, SendingLeadConversionAPIMutationVariable>
) => {
  return useMutation<any, AxiosError, SendingLeadConversionAPIMutationVariable>(
    async ({fbclid, source, medium, content, fbc}) => {
      console.log('fbc!!',fbc)
      try {
        const response = await request.post(`/meta/lead`, 
          {
            fbc
          },
        {
          params : {
            fbclid, source, medium, content
          }
        }
      );
        
        return response
      } catch(e){
        //@ts-ignore
        return e.response
      }
    },
    {
      ...options
    }
  )
}

export default useSendingLeadConversionAPI;